var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAuthenticConnections = function SvgAuthenticConnections(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 189.995,
    height: 114.526,
    viewBox: "0 0 189.995 114.526",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1083",
    "data-name": "Group 1083",
    transform: "translate(-255.62 -2339.713)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1047",
    "data-name": "Group 1047",
    transform: "translate(256.62 2340.712)",
    opacity: 0.432
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1038",
    "data-name": "Group 1038",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1041",
    "data-name": "Group 1041",
    transform: "translate(26.689 8.897)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_893",
    "data-name": "Path 893",
    d: "M-10943-3210c0-35.11,32.2-32.1,32.162-42.739s-11.59-13.106-11.784-27.848,11-23.274,20.41-23.274,12.87,5.173,12.87,5.173",
    transform: "translate(10943 3303.862)",
    fill: "none",
    stroke: "rgba(255,255,255,0.73)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1042",
    "data-name": "Group 1042",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_893-2",
    "data-name": "Path 893",
    d: "M-10943-3210c0-35.11,32.2-32.1,32.162-42.739s-11.59-13.106-11.784-27.848,11-23.274,20.41-23.274,12.87,5.173,12.87,5.173",
    transform: "translate(10943 3303.862)",
    fill: "none",
    stroke: "rgba(255,255,255,0.73)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1044",
    "data-name": "Group 1044",
    transform: "translate(107.646 8.897)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_893-3",
    "data-name": "Path 893",
    d: "M-10889.341-3210c0-35.11-32.2-32.1-32.164-42.739s11.591-13.106,11.785-27.848-11-23.274-20.411-23.274-12.869,5.173-12.869,5.173",
    transform: "translate(10943 3303.862)",
    fill: "none",
    stroke: "rgba(255,255,255,0.73)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1045",
    "data-name": "Group 1045",
    transform: "translate(134.336 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_893-4",
    "data-name": "Path 893",
    d: "M-10889.341-3210c0-35.11-32.2-32.1-32.164-42.739s11.591-13.106,11.785-27.848-11-23.274-20.411-23.274-12.869,5.173-12.869,5.173",
    transform: "translate(10943 3303.862)",
    fill: "none",
    stroke: "rgba(255,255,255,0.73)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_893-2-2",
    "data-name": "Path 893-2",
    d: "M2167.88,1741.559c0-35.111,32.206-32.1,32.163-42.739s-11.59-13.106-11.784-27.846,11-23.274,20.41-23.274c9.177,0,20.826,8.533,20.63,23.274.14,13.162-11.361,18.342-11.417,27.846s31.794,7.631,31.794,42.739",
    transform: "translate(-1858.016 711.679)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAuthenticConnections, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/authentic-connections.60483582.svg";
export { ForwardRef as ReactComponent };